"use strict";

/* global require */
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _q = _interopRequireDefault(require("q"));

var _SetupApp = _interopRequireDefault(require("crm_internal/setup/SetupApp"));

var OnboardingActions = _interopRequireWildcard(require("crm_internal/onboarding/OnboardingActions"));

var _router = _interopRequireDefault(require("crm_ui/router"));

var _AuthRefreshAPI = require("crm_ui/api/AuthRefreshAPI");

var _I18n = _interopRequireDefault(require("I18n"));

var crmRefreshPoller = _interopRequireWildcard(require("crm_ui/utils/crmRefreshPoller"));

var _i18nInit = require("./i18n/i18nInit");

if (!window.Promise) {
  window.Promise = _q.default.Promise;
}
/* global hubspot */
// eslint-disable-next-line hubspot-dev/hubspot-is-special


if (hubspot.preventExecution !== true) {
  _SetupApp.default.setup(_router.default, function () {
    require('crm_internal/onboarding/OnboardingStore');

    require('crm_data/pipelines/StageChangedService');

    require('crm_ui/deals/DealBoardChangeService');

    var crmAssetCache = require('crm_ui/assets/crmAssetCache');

    require('crm_ui/tracking/TrackMobileWebEvents'); // https://git.hubteam.com/HubSpot/CRM-Issues/issues/3575

    /* eslint-disable compat/compat */


    if (navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            if (registration.scope.includes('/contacts/')) {
              registration.unregister();
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    }
    /* eslint-enable compat/compat */


    OnboardingActions.register({
      name: 'recordOnboarding',
      gates: ['CRM:Onboarding:RecordTour']
    });
    OnboardingActions.register({
      name: 'indexOnboarding',
      gates: ['CRM:Onboarding:IndexTour']
    });
    crmAssetCache.maybeStartCRMAssetPoll();
    crmRefreshPoller.startOutdatedVersionPoll();
    setInterval(_AuthRefreshAPI.loginVerifyEcho, _I18n.default.moment.duration(30, 'minutes').valueOf());
  }, _i18nInit.i18nInit, _i18nInit.setI18nLocale);
}